var defaults = {
  duration: 400,
  easing: function easing(currentTime, startValue, diffValue, dureation) {
    return -diffValue * (currentTime /= dureation) * (currentTime - 2) + startValue;
  }
};
var directions = {
  OPEN: 1,
  CLOSE: 2
};
export var slideUp = function slideUp(element) {
  var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (isInteger(args)) {
    args = {
      duration: args
    };
  }

  var options = extend(defaults, args);
  options.direction = directions.CLOSE;
  options.to = 0;
  options.startingHeight = element.scrollHeight;
  options.distanceHeight = -options.startingHeight;
  setElementAnimationStyles(element);
  window.requestAnimationFrame(function (timestamp) {
    return animate(element, options, timestamp);
  });
};
export var slideDown = function slideDown(element) {
  var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (isInteger(args)) {
    args = {
      duration: args
    };
  }

  element.style.height = '0px';
  setElementAnimationStyles(element);
  var options = extend(defaults, args);
  options.direction = directions.OPEN;
  options.to = element.scrollHeight;
  options.startingHeight = 0;
  options.distanceHeight = options.to;
  window.requestAnimationFrame(function (timestamp) {
    return animate(element, options, timestamp);
  });
};

var animate = function animate(element, options, now) {
  if (!options.startTime) {
    options.startTime = now;
  }

  var currentTime = now - options.startTime;
  var animationContinue = currentTime < options.duration;
  var newHeight = options.easing(currentTime, options.startingHeight, options.distanceHeight, options.duration);

  if (animationContinue) {
    element.style.height = "".concat(newHeight.toFixed(2), "px");
    window.requestAnimationFrame(function (timestamp) {
      return animate(element, options, timestamp);
    });
  } else {
    if (options.direction === directions.CLOSE) {
      element.style.display = 'none';
    }

    if (options.direction === directions.OPEN) {
      element.style.display = 'block';
    }

    removeElementAnimationStyles(element);
  }
};

var setElementAnimationStyles = function setElementAnimationStyles(element) {
  element.style.display = 'block';
  element.style.overflow = 'hidden';
  element.style.marginTop = '0';
  element.style.marginBottom = '0';
  element.style.paddingTop = '0';
  element.style.paddingBottom = '0';
};

var removeElementAnimationStyles = function removeElementAnimationStyles(element) {
  element.style.height = null;
  element.style.overflow = null;
  element.style.marginTop = null;
  element.style.marginBottom = null;
  element.style.paddingTop = null;
  element.style.paddingBottom = null;
};

var isInteger = function isInteger(value) {
  if (Number.isInteger) {
    return Number.isInteger(value);
  } else {
    return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
  }
};

var extend = function extend(defaults, options) {
  var extendedOptions = {};

  for (var key in defaults) {
    extendedOptions[key] = options[key] || defaults[key];
  }

  return extendedOptions;
};